import {ngAsync} from 'shared/utils/ng-@decorators';
import {responseToData, unRestangularize} from 'shared/utils/data-service-utils';
import type {RichDocument} from 'typings/portaro.be.types';

/**
 * @ngdoc service
 * @name similarDocumentsDataService
 * @module portaro.components.kp-similar-documents
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing similar documents
 */
export default class SimilarDocumentsDataService {
    public static serviceName = 'similarDocumentsDataService';

    private static readonly RECORDS_ROUTE = 'records';
    private static readonly SIMILAR_DOCUMENT_ROUTE = 'similar';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async query(recordId: string): Promise<RichDocument[]> {
        try {
            return await this.Restangular
                .one(SimilarDocumentsDataService.RECORDS_ROUTE, recordId)
                .one(SimilarDocumentsDataService.SIMILAR_DOCUMENT_ROUTE)
                .get();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}
